import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';

// Used to reet counters
export const siteHeaderWatchOpened = createAction(
  `${actionTypePrefix}.WATCH.OPENED`,
  () => {}
);
export const siteHeaderNotesOpened = createAction(
  `${actionTypePrefix}.NOTES.OPENED`,
  () => {}
);

// User dropdown
export const openUserDropdown = createAction(
  `${actionTypePrefix}.USER.OPEN`,
  () => {}
);
export const closeUserDropdown = createAction(
  `${actionTypePrefix}.USER.CLOSE`,
  () => {}
);
export const userLogoutButtonClicked = createAction(
  `${actionTypePrefix}.LOGOUT_BUTTON.CLICKED`,
  () => {}
);

// Notifications menu
export const openNotificationsDropdown = createAction(
  `${actionTypePrefix}.NOTIFICATIONS.OPEN`,
  () => {}
);
export const closeNotificationsDropdown = createAction(
  `${actionTypePrefix}.NOTIFICATIONS.CLOSE`,
  () => {}
);
export const toggleSubmitMenu = createAction(
  `${actionTypePrefix}.SUBMIT.TOGGLE`,
  () => {}
);
export const toggleFeedbackPage = createAction(
  `${actionTypePrefix}.NOTIFICATIONS.TOGGLE_FEEDBACK_PAGE`,
  () => ({})
);

// Damz menu
export const openDamzDropdown = createAction(
  `${actionTypePrefix}.DAMZ.OPEN`,
  () => {}
);
export const closeDamzDropdown = createAction(
  `${actionTypePrefix}.DAMZ.CLOSE`,
  () => {}
);
export const toggleDamzPage = createAction(
  `${actionTypePrefix}.DAMZ.TOGGLE_PAGE`,
  () => ({})
);

// Search
export const openSearchModal = createAction(
  `${actionTypePrefix}.SEARCH.OPEN`,
  () => {}
);
export const closeSearchModal = createAction(
  `${actionTypePrefix}.SEARCH.CLOSE`,
  () => {}
);
export const toggleSearchModal = createAction(
  `${actionTypePrefix}.SEARCH.TOGGLE`,
  () => {}
);
export const siteHeaderSearchButtonClicked = createAction(
  `${actionTypePrefix}.SEARCH_BUTTON.CLICKED`,
  () => {}
);

// Network bar
export const toggleBurgerMenuRequested = createAction(
  `${actionTypePrefix}.TOGGLE_BURGER_MENU`,
  (isOpenAfter: boolean) => ({ isOpenAfter })
);
